// extracted by mini-css-extract-plugin
var _1 = "SelectMethodStyle-module__bankAccountSvg___Zc_RN";
var _2 = "SelectMethodStyle-module__selectMethod___AirVh";
export { _1 as "bankAccountSvg", _2 as "selectMethod" }
